import {
    NbLogoutComponent,
    NbRequestPasswordComponent,
    NbAuthService,
} from '@nebular/auth';

import { NbAuthComponent } from '@nebular/auth';

import { Component, Inject, OnInit } from '@angular/core';
import { HappyMammaService } from '@hm_app/@core/data/happymamma.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NbToastrService, NbComponentStatus,  NbGlobalLogicalPosition} from '@nebular/theme';



@Component({
    templateUrl: './hm-request-password-component.html',
    styleUrls: ['./hm-request-password-component.css'],
    selector: 'nb-request-password',
})
export class HmRequestPasswordComponent implements OnInit {
    user_email: string;
    username: string;
    success: boolean;
    loading = false;

    is_admin = true;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private hmService: HappyMammaService,
        private modalService: NgbModal,
        protected toastrService: NbToastrService,
    ) {
        this.route.queryParams.subscribe(params => {
            this.is_admin = params["admin"];
        });
    }


    requestNewPassword(event) {
        this.loading = true;

        this.hmService.sendRequestPassword(this.user_email, this.username).subscribe(
            data => {
                this.loading = false;
                this.showToast(
                    'success',
                    'Mail inviata, controlla ' +
                    this.user_email +
                    ' per resettare la password',
                    null,
                );
            },
            error => {
                const e = error.error;
                console.error(error);
                this.loading = false;

                let msg = 'impossibile procedere, verifica i dati inseriti';
                if (e && e.message) {
                    msg = e.message;
                }
                this.showToast(
                    'danger',
                    msg,
                    null,
                );
            },
        );
    }

    private showToast(status: NbComponentStatus, title: string, body: string) {
        const position = NbGlobalLogicalPosition.BOTTOM_END;
        this.toastrService.show(body, title, { position, status} );
    }

    goBackToLogin() {
        this.router.navigate(['/auth/login']);
    }


    async ngOnInit() {

        this.route.queryParams.subscribe(params => {
            console.info('route params', params);

            if (params.user_email) {
                this.user_email = params.user_email;
            }

        });

    }

}
